//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  computed: {
    items () {
      return (this.blok.items || []).map(item => ({
        ...item,
        image: this.$sb.parseImage(item.image),
      }))
    },
  }
}
